<!-- 弹框 -->
<template>
  <el-dialog
      custom-class="window-dialog"
      :visible.sync="dSHow"
      :before-close="handleCancel"
      :width="width">
      <template slot="title">
        <div class="title">{{title}}</div>
        <div class="subTitle" v-if="subTitle">{{subTitle}}</div>
      </template>
      <slot name="bodyContent"></slot>
      <template slot="footer" v-if="showFooter">
        <el-button size="mini" @click="handleCancel">{{$t('order.Cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="handleSure" :loading="loading">{{$t('order.Confirm')}}</el-button>
      </template>
  </el-dialog>
</template>
<script>


export default {
  name: 'winDialog',
  components: {},
  props: {
    // 标题
    title: {
      type: String,
      default: '提示',
      require: true
    },
    // 二级标题
    subTitle: {
      type: String,
      default: ''
    },
    handleClose: {
      type: Function,
      default: () => {
        return () => {}
      }
    },
    // 取消回调
    cancel: {
      type: Function,
      default: null
    },
    // 确定回调
    sure: {
      type: Function,
      default: null
    },
    // 弹框显示隐藏
    dialogShow: {
      type: Boolean,
      default: false
    },
    // 提交按钮loding
    loading: {
      type: Boolean,
      default: false
    },
    // 显示底部按钮
    showFooter: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '700px'
    },
    // 弹框关闭后的方法
    closeAfter: {
      type: Function,
      default: () => {
        return () => {}
      }
    }
  },
  data() {
    return {}
  },

  computed: {
    dSHow() {
      return this.dialogShow
    }
  },

  watch: {},

  mounted() {},

  methods: {
    // 取消方法
    handleCancel() {
      if (typeof this.cancel === 'function') {
        this.cancel(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 确认方法
    handleSure() {
      if (typeof this.sure === 'function') {
        this.sure(() => {
          this.closeDialog()
        })
      } else {
        this.closeDialog()
      }
    },
    // 弹框关闭
    closeDialog() {
      this.$emit("update:dialogShow", false)
      this.closeAfter()
    }
  }
}
</script>
<style lang="stylus">

.window-dialog {
  width: 700px;

  .el-dialog__header {
    background-color: $color-main;
    padding: 12px 20px;
    box-sizing: border-box;
    color: $color-white;

    .title {
      font-size: 18px;
      font-weight: 500;
    }

    .subTitle {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__close {
    color: $color-white;
    opacity: .65;
  }

  .el-dialog__headerbtn {
    top: 13px;

    &:hover {
      .el-dialog__close {
        color: $color-white;
        opacity: 1;
      }
    }
  }

  .el-dialog__footer {
    text-align: center;
    padding:0 !important;
  }
}
</style>
